import {getStore, setStore} from '@/utils/store'

const doctor = {
  namespaced: true,
  state: {
    // 左侧导航被选中的key
    activeMenuKey: '',
    // 浏览器高宽
    windowWidth: 0,
    windowHeight: 0,
    // 中间容器高宽
    mainContentWidth: 0,
    mainContentHeight: 0,
    // 被编辑的病历数据
    editedMedicalRecordData: null,
    // 被查看的病历数据
    showedMedicalRecordData: null,
    // 健康辨识病情种类
    tongueDiseaseList: [],
    // 健康辨识模块当前选择的病种编码
    currentIllnessDiseaseCode: getStore({name: 'currentIllnessDiseaseCode'}) || 'C00.D00',
    // 健康辨识模块当前选择的病种名称
    currentIllnessDiseaseName: getStore({name: 'currentIllnessDiseaseName'}) || '中医体质健康状态',
    // 健康辨识模块当前选择的病种版本
    currentIllnessDiseaseApiVer: getStore({name: 'currentIllnessDiseaseApiVer'}) || 0,
    // 被编辑的病情辨识数据
    illnessRecordData: null
  },
  actions: {},
  mutations: {
    SET_ACTIVE_MENU_KEY: (state, activeMenuKey) => {
      state.activeMenuKey = activeMenuKey
    },
    SET_WINDOW_WIDTH: (state, windowWidth) => {
      state.windowWidth = windowWidth
    },
    SET_WINDOW_HEIGHT: (state, windowHeight) => {
      state.windowHeight = windowHeight
    },
    SET_MAIN_CONTENT_WIDTH: (state, mainContentWidth) => {
      state.mainContentWidth = mainContentWidth
    },
    SET_MAIN_CONTENT_HEIGHT: (state, mainContentHeight) => {
      state.mainContentHeight = mainContentHeight
    },
    SET_EDITED_MEDICAL_RECORD_DATA: (state, editedMedicalRecordData) => {
      state.editedMedicalRecordData = editedMedicalRecordData
    },
    SET_ILLNESS_RECORD_DATA: (state, illnessRecordData) => {
      state.illnessRecordData = illnessRecordData
    },
    SET_SHOWED_MEDICAL_RECORD_DATA: (state, showedMedicalRecordData) => {
      state.showedMedicalRecordData = showedMedicalRecordData
    },
    SET_TONGUE_DISEASE_LIST: (state, tongueDiseaseList) => {
      state.tongueDiseaseList = tongueDiseaseList
    },
    SET_CURRENT_ILLNESS_DISEASE_CODE: (state, currentIllnessDiseaseCode) => {
      state.currentIllnessDiseaseCode = currentIllnessDiseaseCode
      setStore({
        name: 'currentIllnessDiseaseCode',
        content: state.currentIllnessDiseaseCode
      })
    },
    SET_CURRENT_ILLNESS_DISEASE_NAME: (state, currentIllnessDiseaseName) => {
      state.currentIllnessDiseaseName = currentIllnessDiseaseName
      setStore({
        name: 'currentIllnessDiseaseName',
        content: state.currentIllnessDiseaseName
      })
    },
    SET_CURRENT_ILLNESS_DISEASE_APIVER: (state, currentIllnessDiseaseApiVer) => {
      state.currentIllnessDiseaseApiVer = currentIllnessDiseaseApiVer
      setStore({
        name: 'currentIllnessDiseaseApiVer',
        content: state.currentIllnessDiseaseApiVer
      })
    }
  }
}

export default doctor



// WEBPACK FOOTER //
// ./src/store/modules/doctor.js